export const getCivilites = ({ page } = { page: 1 }) => `/api/transverse/civilites?page=${page}`;
